var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenDropdown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.165,
    height: 8.355,
    viewBox: "0 0 13.165 8.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5871",
    "data-name": "Path 5871",
    d: "M-9351.2-41.944l4.8,4.819,4.825-4.819",
    transform: "translate(9352.972 43.712)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDropdown);
export default __webpack_public_path__ + "static/media/open-dropdown.70ccae1d3230ceb7082da3ccbed46729.svg";
export { ForwardRef as ReactComponent };